import { Dialog } from '@mui/material';
import { ButtonStyled, PopupTitle, WrapperActions, DescriptionStyled, DialogContentStyled } from './CloseQuizPopup.styled';


export const CloseQuizPopup = ({ open, onConfirm, onCancel }) => {
    
    return (
        <Dialog
            open={open}
            onClose={onCancel}
        >

            <PopupTitle>
                Sei sicuro di voler uscire dal Quiz?
            </PopupTitle>

            <DialogContentStyled>

                <DescriptionStyled>
                    Se esci ora tutte le risposte saranno cancellate e dovrai iniziare il Quiz da capo.
                </DescriptionStyled>

            </DialogContentStyled>

            <WrapperActions>               
                
                <ButtonStyled onClick={onCancel} variant='contained' color="benjamin">
                    torna al quiz
                </ButtonStyled>
                <ButtonStyled onClick={onConfirm} variant='outlined' color='benjamin'>
                    esci dal quiz
                </ButtonStyled>
                
            </WrapperActions>
        </Dialog>
    );
};